import { render } from "./PageSectionHeader.vue?vue&type=template&id=28acf9a2"
import script from "./PageSectionHeader.vue?vue&type=script&lang=js"
export * from "./PageSectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__